export default __webpack_public_path__ + "static/6_21-8a0df51b40dd6d64eb543ac0f1064bca.png";